import { IFormInputProps } from 'cng-common/features/form/components/formInput/models'
import { OnboardingFormInput } from 'onboarding/components/ui/theme'

import { TAdaptingDisabled } from './types'

export const OnboardingFormInputAdapter = <T extends string | number>({
  disabled,
  isDisabled,
  ...props
}: IFormInputProps<T> & TAdaptingDisabled) => (
  <OnboardingFormInput {...props} isDisabled={isDisabled || disabled} />
)
